import React from 'react'
import { useMediaQuery } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import BasePage from 'src/components/layouts/BasePage'
import DocumentTitle from 'src/components/common/DocumentTitle'
import { useTrialDashboardPageStyles } from '../shared/useTrialDashboardPageStyles'
import TrialOverDashboardDesktop from './desktop/TrialOverDashboardDesktop'
import TrialOverDashboardMobile from './mobile/TrialOverDashboardMobile'

// A cancelled account never reaches here any more: DashboardComponent branches on `!isSubscribed`
// first and renders DeactivatedDashboard (ENG-1532). This screen is now only ever the
// trial-expired case, so its old isChurned redirect is gone.
export default function TrialOverDashboard() {
  const classes = useTrialDashboardPageStyles()
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))

  return (
    <BasePage className={classes.basePage} width="xl">
      <DocumentTitle title="Trial Expired" />
      {isMobile ? <TrialOverDashboardMobile /> : <TrialOverDashboardDesktop />}
    </BasePage>
  )
}
